module.exports = __webpack_public_path__ + "img/8F894E_DAD79B_C9C384_C4BE7B-256px.096f4d56.png";